import { defineComponent, ref, reactive, computed, provide, watch, nextTick, toRef, unref, onMounted, PropType, toRefs } from 'vue';
import { FilterModel } from '@Apps/Search/Src/Models/FilterModel';
import CombinedFilter from '@Components/CombinedFilter/CombinedFilterComponent.vue';
import ICombinedFilterComponent from '@Components/CombinedFilter/ICombinedFilterComponent';
import appTranslations from '@Apps/MapSearch/Translations/VueTranslations';

export default defineComponent({

    components: { CombinedFilter },

    props: {

        filter: {
            type: Object as PropType<FilterModel>,
            required: true
        },
        isVisible: Boolean,
        forceHideContentTitle: Boolean,
        totalCount: Number


    },

    emits: ["onClose"],


    setup(props, context) {

        const combinedFilterInstance = ref<ICombinedFilterComponent | null>(null);
        const isVisible = toRef(props, 'isVisible');
        const filter = toRef(props, 'filter');
        const totalCount = toRef(props, 'totalCount');

        const onClose = () => {


            context.emit("onClose")
        };


        const onFocusArea = (area: string | undefined) => {

            combinedFilterInstance.value?.onFocusArea(area);
        };



        return {

            // component refs
            combinedFilterInstance,

            // event actions external
            onFocusArea,

            //--

            onClose,
            isVisible,
            filter,
            totalCount,
            forceHideContentTitle: props.forceHideContentTitle || false,
            confirmBtn_Label: appTranslations.filter_Confirm

        };




    }

});

